<!--sidebar-->
<c-sidebar
  #sidebar1="cSidebar"
  class="d-print-none sidebar sidebar-fixed"
  id="sidebar1"
  visible
>
  <div class="sidebar-header">
    <c-sidebar-brand
      [brandFull]="{
        src: 'assets/img/brand/alpuraBnHz.svg',
        width: 150,
        height: 53.5,
        alt: 'alpura'
      }"
      [brandNarrow]="{
        src: 'assets/img/brand/alpuraBnHzMin.svg',
        width: 46,
        height: 46,
        alt: 'alpura'
      }"
      [routerLink]="'/dashboard'"
    >
    </c-sidebar-brand>
  </div>
  <ul class="sidebar-nav" style="font-size: 14px">
    <ng-container *ngFor="let item of filteredNavs">
      <ng-template
        [ngIf]="!!item.children && item.children.length > 0"
        [ngIfElse]="notChildren1"
      >
        <li
          class="nav-item nav-group"
          [class]="{ show: !!item.show }"
          [hidden]="item.attributes?.hidden"
        >
          <a class="nav-link nav-group-toggle" (click)="item.show = !item.show">
            <i [class]="item.icon + ' me-2'"></i> {{ item.name }}
          </a>
          <ul class="nav-group-items">
            <ng-container *ngFor="let item2 of item.children">
              <ng-template
                [ngIf]="!!item2.children && item2.children.length > 0"
                [ngIfElse]="notChildren2"
              >
                <li
                  class="nav-item nav-group ps-2"
                  [class]="{ show: !!item2.show }"
                  [hidden]="item2.attributes?.hidden"
                >
                  <a
                    class="nav-link nav-group-toggle"
                    (click)="item2.show = !item2.show"
                  >
                    <i [class]="item2.icon + ' me-2'"></i> {{ item2.name }}
                  </a>
                  <ul class="nav-group-items ps-4">
                    <ng-container *ngFor="let item3 of item2.children">
                      <li class="nav-item" [hidden]="item3.attributes?.hidden">
                        <a class="nav-link" [routerLink]="item3.url" routerLinkActive="active">
                          <i [class]="item3.icon + ' me-2'"></i>
                          {{ item3.name }}
                        </a>
                      </li>
                    </ng-container>
                  </ul>
                </li>
              </ng-template>

              <ng-template #notChildren2>
                <li class="nav-item ps-2" [hidden]="item2.attributes?.hidden">
                  <a class="nav-link" [routerLink]="item2.url" routerLinkActive="active">
                    <i [class]="item2.icon + ' me-2'"></i> {{ item2.name }}
                  </a>
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </li>
      </ng-template>

      <ng-template #notChildren1>
        <li class="nav-item" [hidden]="item.attributes?.hidden">
          <a class="nav-link" [routerLink]="item.url" routerLinkActive="active">
            <i [class]="item.icon + ' me-2'"></i> {{ item.name }}
          </a>
        </li>
      </ng-template>
    </ng-container>
  </ul>
  <c-sidebar-footer class="bg-transparent p-2 sidebar-footer">
    <div class="input-group" [formGroup]="searchMenu">
      <span
        class="input-group-text"
        style="background-color: #0e295a; color: white"
        ><i class="fa-solid fa-magnifying-glass"></i
      ></span>
      <input
        type="text"
        class="form-control"
        placeholder="Buscar componente"
        aria-label="Buscar"
        style="background-color: #0e295a; color: white"
        formControlName="search"
      />
      <button
        type="button"
        class="btn btn-outline-secondary"
        *ngIf="searchMenu.valid"
        (click)="resetFilter()"
      >
        <i class="fa-solid fa-close"></i>
      </button>
    </div>
  </c-sidebar-footer>
</c-sidebar>

<!--aside-->
<app-default-aside style="display: none"></app-default-aside>

<!--main-->
<div class="wrapper d-flex flex-column min-vh-100 bg-light dark:bg-transparent">
  <!--app-header-->
  <app-default-header
    class="mb-4 d-print-none header header-sticky"
    position="sticky"
    sidebarId="sidebar1"
  ></app-default-header>
  <!--app-body-->
  <div class="body flex-grow-1 px-3">
    <!-- <c-container breakpoint="lg" class="h-auto"> -->
    <router-outlet></router-outlet>
    <!-- </c-container> -->
  </div>
  <!--app footer-->
  <app-default-footer></app-default-footer>
</div>
